// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/CircularStd-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/CircularStd-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/CircularStd-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/CircularStd-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/CircularStd-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/images/head-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Circular Std Book';
  src: local('Circular Std Book'), local('Circular-Std-Book'),
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-style: normal;
}

@font-face {
  font-family: 'Circular Std Bold';
  src: local('Circular Std Bold'), local('Circular-Std-Bold'),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-style: normal;
}

@font-face {
  font-family: 'Circular Std Medium';
  src: local('Circular Std Medium'), local('Circular-Std-Medium'),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-style: normal;
}

body {
  margin: 0;
  font-family: 'Circular Std Book' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #828282;
  background-color: rgb(248,249,250) !important;
  overflow: hidden; /* Prevent page-level scrollbar */
}

.second-font {
  font-family: 'Fira Sans';
}

.css-13cymwt-control, .css-13cymwt-control:active, .css-13cymwt-control:focus, .css-13cymwt-control, .css-13cymwt-control:focus, .css-13cymwt-control:active {
  width: 100%;
  background-color: #F2F2F2 !important;
  padding: 10px 5px !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 2px solid #000000 !important;
}

.react-code-input 

.form-floating > label {
  z-index: 0 !important;
}
/* .float-input {
  background-color: #F2F2F2 !important;
} */
.float-input label {
  color: #807E7C !important;
}

.float-input label::after {
  background-color: transparent !important;
}

.float-input select, .float-input input {
  background-color: #F2F2F2 !important;
  padding-top: 27px !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 2px solid #000000 !important;
}

.float-input select:hover, .float-input select:focus {
  background-color: #F2F2F2 !important;
  padding-top: 27px !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 2px solid #008CFE !important;
}

.input-field {
  padding: 15px !important;
  border: none !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 2px solid #000000 !important;
  background-color: #F2F2F2 !important;
}

.input-field:hover,
.input-field:focus {
  padding: 15px !important;
  border: none !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 2px solid #008CFE !important;
  background-color: #F2F2F2 !important;
}

/* ::placeholder {
  color: transparent !important;
}

::-ms-input-placeholder {
  color: transparent !important;
} */

.first-font {
  font-family: 'Circular Std Book' !important;
}
.first-font-medium {
  font-family: 'Circular Std Medium' !important;
}
.first-font-bold {
  font-family: 'Circular Std Bold' !important;
}

.darker-text {
  color: #1B1C1E;
}

.dark-text {
  color: #828282;
}

.light-text {
  color: #BDBDBD;
}

.primary-text {
  color: #008CFE !important;
}

.blue-text {
  color: #03256C !important;
}

.text-dark-orange {
  color: #854C27 !important;
}

.orange-text {
  color: #DD7230;
}

.red-text {
  color: #EB5757;
}

.yellow-text {
  color: #FCAB10;
}

.green-text {
  color: #44AF69;
}

.btn-text {
  font-size: 15px;
}

.btn-primary {
  background-color: #008CFE;
  color: #FFFFFF;
  padding: 15px 40px;
  border: 2px solid #008CFE;
  font-size: 15px;
  border-radius: 10px;
  transition: 300ms ease-out;
}

.btn-primary-outline {
  background-color: rgba(0, 140, 254, 0.07);
  color: #008CFE;
  padding: 10px 0px;
  font-size: 15px;
  border: 2px solid rgba(0, 140, 254, 0.0);
  border-radius: 10px;
  transition: 300ms ease-out;
}

.btn-hover-primary {
  font-size: 12px !important;
}

.btn-hover-primary:hover {
  background-color: #008CFE !important;
  color: #FFFFFF !important;
}

.btn-primary-outline:hover {
  border: 2px solid #008CFE;
  transition: 300ms ease-in-out;
}

.btn-secondary-outline {
  background-color: #F2F2F2;
  color: #807E7C;
  padding: 10px 0px;
  font-size: 15px;
  border: 2px solid #F2F2F2;
  border-radius: 10px;
  transition: 300ms ease-out;
}

.btn-secondary-outline:hover {
  border: 2px solid #008CFE;
  transition: 300ms ease-in-out;
}

.btn-light-blue {
  background-color: #6CB8F8;
  color: #FFFFFF;
  border-radius: 20px;
  font-size: 15px;
  border: none;
  padding: 5px 10px;
}

.btn-orange {
  background-color: #F2994A;
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  padding: 5px 10px;
}

.btn-green {
  background-color: #219653;
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  padding: 5px 10px;
}

.btn-light-green {
  background-color: #6CB48B;
  color: #FFFFFF;
  border-radius: 20px;
  font-size: 15px;
  border: none;
  padding: 5px 10px;
}

.btn-light-red {
  background-color: #EB57571A;
  color: #EB5757;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  padding: 15px 40px;
}

.btn-orange-light {
  background-color: #FCAB10;
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  padding: 10px 10px;
}

.btn-yellow {
  background-color: #F6CA53;
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  padding: 10px 10px;
}

.btn-with-icon {

}

.bg-primary {
  background-color: #008CFE;
}

.bg-light-blue {
  background-color: #6CB8F8;
}

.bg-lighter-blue {
  background-color: rgba(0, 140, 254, 0.1);
}

.bg-light-green {
  background-color: #6CB48B;
}

.bg-primary-outline {
  background-color: rgba(0, 140, 254, 0.07);
}

.bg-secondary {
  background-color: rgba(128, 126, 124, 1);
}

.bg-outline-secondary {
  background-color: rgba(128, 126, 124, 0.05) !important;
}

.bg-dark-blue {
  background-color: #03256C;
}

.bg-dark-orange {
  background-color: #854C27;
}

.bg-orange {
  background-color: #DD7230;
}

.bg-orange-light {
  background-color: #FCAB10;
}

.bg-green {
  background-color: #44AF69;
}
.bg-dark-green {
  background-color: #219653;
}

h1 {
  font-size: 55px !important;
}

h2 {
  font-size: 46px !important;
}

h3 {
  font-size: 36px !important;
}

h4 {
  font-size: 30px !important;
}

h5 {
  font-size: 26px !important;
}

h6 {
  font-size: 20px !important;
}

.font-size-lg {
  font-size: 20px;
}
.font-size-mid {
  font-size: 18px;
}
.font-size-normal {
  font-size: 16px !important;
}

.font-size-sm {
  font-size: 14px;
}
.font-size-smm {
  font-size: 12px;
}
/* 
p {
  font-size: 16px;
}

span {
  font-size: 16px;
} */

.card-bl-primary {
  border-left: 7px solid #008CFE;
}
.card-bl-green {
  border-left: 7px solid #219653;
}
.card-bl-yellow {
  border-left: 7px solid #F49F0A;
}
.card-bl-purple {
  border-left: 7px solid #5550EA;
}
.card-bl-red {
  border-left: 7px solid #EB5757;
}

/* .dropdown-toggle {
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.dropdown-item:hover {
  background-color: transparent !important;
} */

/* Define a keyframe animation named "shake" */
@keyframes shake {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-3px);
  }

  40% {
    transform: translateX(3px);
  }

  60% {
    transform: translateX(-3px);
  }

  80% {
    transform: translateX(3px);
  }

  100% {
    transform: translateX(0);
  }
}

/* Apply the animation to elements with the "shake1" class on hover */
.shake1:hover {
  animation: shake 0.5s ease-in-out;
  animation-iteration-count: 1;
  /* Run the animation once */
}

.card-default .progress {
  height: 5px;
  width: 90%;
}

.card-default .progress-bar {
  border-radius: 30px;
  background-color: #008CFE;
}

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.card-button {
  background-color: #F2F2F2;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
}

.card-button .view-all {
  display: none;
}

.card-button:hover .view-all {
  display: block;
}

.card-button:hover {
  background-color: rgba(0, 140, 254, 0.07);
}

.apexcharts-xaxis .apexcharts-text tspan {
  color: #828282;
  font-size: 14px;
  font-family: 'Circular Std Book' !important;
  font-weight: normal;
  line-height: 15.336px;
}

.apexcharts-yaxis-texts-g {
  text-align: start !important;
}
.apexcharts-xaxis-texts-g, .apexcharts-xaxis-inversed-texts-g {
  text-align: start !important;
}

.apexcharts-yaxis .apexcharts-text tspan {
  color: #1B1C1E;
  font-size: 16px;
  font-family: 'Circular Std Bold' !important;
  font-weight: 800;
  line-height: 15.336px;
}

.apexcharts-bar-series .apexcharts-series {
  margin: 30px 0px !important;
}

.apexcharts-legend.apx-legend-position-bottom {
  justify-content: left !important;
}

.apexcharts-legend-series {
  margin-top: 20px !important;
}

.apexcharts-legend .apexcharts-legend-text {
  font-size: 15px !important;
  font-family: 'Circular Std Bold' !important;
}

.form-input:focus, .form-control:focus, .form-control:active, input:focus, input:active,  .form-select:focus, input:focus, textarea:focus, select:focus{
  outline: none !important;
  border: none !important;
}

.table thead tr {
  border-bottom: 1px solid #000000;
}
.table, .table thead tr th, .table tbody tr td  {
  background-color: transparent !important;
  padding: 12px 4px !important;
}

.exchangeIcon {
  transform: rotate(90deg) !important;
}

.modal-head-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  border-radius: 5px;
}


/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.offcanvas-header {
  text-align: end !important;
  display: block !important;
}

.form-check-input:focus, .form-check-input:active {
  outline: none !important;
}
.form-check-input:checked {
  outline: none !important;
  background-color: #008CFE !important;
  border-color: #008CFE !important;
}

.big-text.big-content { 
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invoiceTable {
  height: 25vh;
  max-height: -moz-fit-content;
  max-height: fit-content;
}

.invoiceTable, .invoiceTable td, .invoiceTable th, .invoiceTable thead, .invoiceTable thead tr, .invoiceTable thead tr td {
  border: none !important;
}

/* Custom Scrollbar Styles */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Ensure scrollbars are visible only when needed */
* {
  -ms-overflow-style: auto;
  scrollbar-width: auto;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
  padding: 2px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #008CFE;
  border-radius: 5px;
  width: 8px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #007ee4;
}

.truncate-cell {
  max-width: 30vw; /* Adjust the max-width as needed */
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  text-wrap: nowrap;
  word-wrap: normal;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
}

.truncate-cell img {
  display: none;
}

.richText-content img {
  width: 60%;
  height: auto;
}

.file-upload-container {
  border: #807E7C 1px dashed;
  padding: 20px;
  text-align: center;
}

.search-area svg {
  z-index: 1;
  margin: auto;
}
.search-area .search-input {
  outline: none !important;
  border: none !important;
  margin-left: -40px;
  padding: 8px 50px;
  width: 400px;
}

@media screen and (max-width: 700px) {
  .truncate-cell {
    max-width: 90vw; /* Adjust the max-width as needed */
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
  }
  
  .richText-content img {
    width: 90%;
    height: auto;
  }
}


.chat-input {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.attachment-input .attachments {
  display: flex;
}

.attachment-preview {
  position: relative;
  margin-right: 10px;
}

.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.remove-btn {
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
}

.text-input input {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
}

.audio-preview {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.remove-btn, .record-again-btn {
  margin-left: 10px;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
}

.record-again-btn {
  background-color: blue;
}

.record-btn {
  background-color: blue;
  color: white;
  padding: 10px;
  cursor: pointer;
}

.send-btn {
  align-self: flex-end;
  background-color: green;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
}

.PhoneInputCountryIconImg {
  width: 60px;
  position: relative;
}

.PhoneInput {
  margin-left: 0px;
  background-color: #F2F2F2 !important;
  padding: 11px  !important;
  color: #363636 !important;
  border-radius: 10px 10px 0px 0px !important;
  border: none;
  border-bottom: 2px solid #000000 !important;
}

.PhoneInputInput {
  border: none;
  background-color: #F2F2F2 !important;
}


.gpdr-button {
  text-align: start;
  padding: 10px 30px;
  border: none;
  background-color: transparent;
  display: block;
  border-radius: 50px;
  width: 100%;
}

.gpdr-button:hover {
  font-weight: 600;
  padding: 10px 30px;
  border: none;
  background-color: #B3DDFF;
  display: block;
  border-radius: 50px;
}

.invoice-width {
  width: 60% !important;
}

.enterpriseTab.active {
  background-color: #008CFE !important;
  color: #fff !important;
}

.status-pending {
  background-color: #F6CA53 !important;
  color: white !important;
  border: none !important;
}

.status-resolved {
  background-color: #219653 !important;
  color: white !important;
  border: none !important;
}

.sticky-thead thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC;gEACiE;EACjE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC;gEACiE;EACjE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;;;gEAGmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,mCAAmC;EACnC,kCAAkC;EAClC,cAAc;EACd,6CAA6C;EAC7C,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,4BAA4B;EAC5B,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;;EAGE,qBAAqB;AACvB;AACA;;GAEG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;EAC3C,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;;;;;;GAMG;;AAEH;EACE,2CAA2C;AAC7C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;AAEA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;GAOG;;AAEH;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;GAYG;;AAEH,8CAA8C;AAC9C;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qEAAqE;AACrE;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yDAAkD;EAClD,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,4BAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,mCAAmC;EACpD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,eAAe,EAAE,mCAAmC;IACpD,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":["@font-face {\n  font-family: 'Circular Std Book';\n  src: local('Circular Std Book'), local('Circular-Std-Book'),\n      url('./assets/fonts/CircularStd-Book.ttf') format('truetype');\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Circular Std Bold';\n  src: local('Circular Std Bold'), local('Circular-Std-Bold'),\n      url('./assets/fonts/CircularStd-Bold.ttf') format('truetype');\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Circular Std Medium';\n  src: local('Circular Std Medium'), local('Circular-Std-Medium'),\n      url('./assets/fonts/CircularStd-Medium.woff2') format('woff2'),\n      url('./assets/fonts/CircularStd-Medium.woff') format('woff'),\n      url('./assets/fonts/CircularStd-Medium.ttf') format('truetype');\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Circular Std Book' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #828282;\n  background-color: rgb(248,249,250) !important;\n  overflow: hidden; /* Prevent page-level scrollbar */\n}\n\n.second-font {\n  font-family: 'Fira Sans';\n}\n\n.css-13cymwt-control, .css-13cymwt-control:active, .css-13cymwt-control:focus, .css-13cymwt-control, .css-13cymwt-control:focus, .css-13cymwt-control:active {\n  width: 100%;\n  background-color: #F2F2F2 !important;\n  padding: 10px 5px !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border-bottom: 2px solid #000000 !important;\n}\n\n.react-code-input \n\n.form-floating > label {\n  z-index: 0 !important;\n}\n/* .float-input {\n  background-color: #F2F2F2 !important;\n} */\n.float-input label {\n  color: #807E7C !important;\n}\n\n.float-input label::after {\n  background-color: transparent !important;\n}\n\n.float-input select, .float-input input {\n  background-color: #F2F2F2 !important;\n  padding-top: 27px !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border-bottom: 2px solid #000000 !important;\n}\n\n.float-input select:hover, .float-input select:focus {\n  background-color: #F2F2F2 !important;\n  padding-top: 27px !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border-bottom: 2px solid #008CFE !important;\n}\n\n.input-field {\n  padding: 15px !important;\n  border: none !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border-bottom: 2px solid #000000 !important;\n  background-color: #F2F2F2 !important;\n}\n\n.input-field:hover,\n.input-field:focus {\n  padding: 15px !important;\n  border: none !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border-bottom: 2px solid #008CFE !important;\n  background-color: #F2F2F2 !important;\n}\n\n/* ::placeholder {\n  color: transparent !important;\n}\n\n::-ms-input-placeholder {\n  color: transparent !important;\n} */\n\n.first-font {\n  font-family: 'Circular Std Book' !important;\n}\n.first-font-medium {\n  font-family: 'Circular Std Medium' !important;\n}\n.first-font-bold {\n  font-family: 'Circular Std Bold' !important;\n}\n\n.darker-text {\n  color: #1B1C1E;\n}\n\n.dark-text {\n  color: #828282;\n}\n\n.light-text {\n  color: #BDBDBD;\n}\n\n.primary-text {\n  color: #008CFE !important;\n}\n\n.blue-text {\n  color: #03256C !important;\n}\n\n.text-dark-orange {\n  color: #854C27 !important;\n}\n\n.orange-text {\n  color: #DD7230;\n}\n\n.red-text {\n  color: #EB5757;\n}\n\n.yellow-text {\n  color: #FCAB10;\n}\n\n.green-text {\n  color: #44AF69;\n}\n\n.btn-text {\n  font-size: 15px;\n}\n\n.btn-primary {\n  background-color: #008CFE;\n  color: #FFFFFF;\n  padding: 15px 40px;\n  border: 2px solid #008CFE;\n  font-size: 15px;\n  border-radius: 10px;\n  transition: 300ms ease-out;\n}\n\n.btn-primary-outline {\n  background-color: rgba(0, 140, 254, 0.07);\n  color: #008CFE;\n  padding: 10px 0px;\n  font-size: 15px;\n  border: 2px solid rgba(0, 140, 254, 0.0);\n  border-radius: 10px;\n  transition: 300ms ease-out;\n}\n\n.btn-hover-primary {\n  font-size: 12px !important;\n}\n\n.btn-hover-primary:hover {\n  background-color: #008CFE !important;\n  color: #FFFFFF !important;\n}\n\n.btn-primary-outline:hover {\n  border: 2px solid #008CFE;\n  transition: 300ms ease-in-out;\n}\n\n.btn-secondary-outline {\n  background-color: #F2F2F2;\n  color: #807E7C;\n  padding: 10px 0px;\n  font-size: 15px;\n  border: 2px solid #F2F2F2;\n  border-radius: 10px;\n  transition: 300ms ease-out;\n}\n\n.btn-secondary-outline:hover {\n  border: 2px solid #008CFE;\n  transition: 300ms ease-in-out;\n}\n\n.btn-light-blue {\n  background-color: #6CB8F8;\n  color: #FFFFFF;\n  border-radius: 20px;\n  font-size: 15px;\n  border: none;\n  padding: 5px 10px;\n}\n\n.btn-orange {\n  background-color: #F2994A;\n  color: #FFFFFF;\n  border-radius: 10px;\n  font-size: 15px;\n  border: none;\n  padding: 5px 10px;\n}\n\n.btn-green {\n  background-color: #219653;\n  color: #FFFFFF;\n  border-radius: 10px;\n  font-size: 15px;\n  border: none;\n  padding: 5px 10px;\n}\n\n.btn-light-green {\n  background-color: #6CB48B;\n  color: #FFFFFF;\n  border-radius: 20px;\n  font-size: 15px;\n  border: none;\n  padding: 5px 10px;\n}\n\n.btn-light-red {\n  background-color: #EB57571A;\n  color: #EB5757;\n  border-radius: 10px;\n  font-size: 15px;\n  border: none;\n  padding: 15px 40px;\n}\n\n.btn-orange-light {\n  background-color: #FCAB10;\n  color: #FFFFFF;\n  border-radius: 10px;\n  font-size: 15px;\n  border: none;\n  padding: 10px 10px;\n}\n\n.btn-yellow {\n  background-color: #F6CA53;\n  color: #FFFFFF;\n  border-radius: 10px;\n  font-size: 15px;\n  border: none;\n  padding: 10px 10px;\n}\n\n.btn-with-icon {\n\n}\n\n.bg-primary {\n  background-color: #008CFE;\n}\n\n.bg-light-blue {\n  background-color: #6CB8F8;\n}\n\n.bg-lighter-blue {\n  background-color: rgba(0, 140, 254, 0.1);\n}\n\n.bg-light-green {\n  background-color: #6CB48B;\n}\n\n.bg-primary-outline {\n  background-color: rgba(0, 140, 254, 0.07);\n}\n\n.bg-secondary {\n  background-color: rgba(128, 126, 124, 1);\n}\n\n.bg-outline-secondary {\n  background-color: rgba(128, 126, 124, 0.05) !important;\n}\n\n.bg-dark-blue {\n  background-color: #03256C;\n}\n\n.bg-dark-orange {\n  background-color: #854C27;\n}\n\n.bg-orange {\n  background-color: #DD7230;\n}\n\n.bg-orange-light {\n  background-color: #FCAB10;\n}\n\n.bg-green {\n  background-color: #44AF69;\n}\n.bg-dark-green {\n  background-color: #219653;\n}\n\nh1 {\n  font-size: 55px !important;\n}\n\nh2 {\n  font-size: 46px !important;\n}\n\nh3 {\n  font-size: 36px !important;\n}\n\nh4 {\n  font-size: 30px !important;\n}\n\nh5 {\n  font-size: 26px !important;\n}\n\nh6 {\n  font-size: 20px !important;\n}\n\n.font-size-lg {\n  font-size: 20px;\n}\n.font-size-mid {\n  font-size: 18px;\n}\n.font-size-normal {\n  font-size: 16px !important;\n}\n\n.font-size-sm {\n  font-size: 14px;\n}\n.font-size-smm {\n  font-size: 12px;\n}\n/* \np {\n  font-size: 16px;\n}\n\nspan {\n  font-size: 16px;\n} */\n\n.card-bl-primary {\n  border-left: 7px solid #008CFE;\n}\n.card-bl-green {\n  border-left: 7px solid #219653;\n}\n.card-bl-yellow {\n  border-left: 7px solid #F49F0A;\n}\n.card-bl-purple {\n  border-left: 7px solid #5550EA;\n}\n.card-bl-red {\n  border-left: 7px solid #EB5757;\n}\n\n/* .dropdown-toggle {\n  background-color: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.dropdown-item:hover {\n  background-color: transparent !important;\n} */\n\n/* Define a keyframe animation named \"shake\" */\n@keyframes shake {\n  0% {\n    transform: translateX(0);\n  }\n\n  20% {\n    transform: translateX(-3px);\n  }\n\n  40% {\n    transform: translateX(3px);\n  }\n\n  60% {\n    transform: translateX(-3px);\n  }\n\n  80% {\n    transform: translateX(3px);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n/* Apply the animation to elements with the \"shake1\" class on hover */\n.shake1:hover {\n  animation: shake 0.5s ease-in-out;\n  animation-iteration-count: 1;\n  /* Run the animation once */\n}\n\n.card-default .progress {\n  height: 5px;\n  width: 90%;\n}\n\n.card-default .progress-bar {\n  border-radius: 30px;\n  background-color: #008CFE;\n}\n\n.dot {\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.card-button {\n  background-color: #F2F2F2;\n  padding: 10px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.card-button .view-all {\n  display: none;\n}\n\n.card-button:hover .view-all {\n  display: block;\n}\n\n.card-button:hover {\n  background-color: rgba(0, 140, 254, 0.07);\n}\n\n.apexcharts-xaxis .apexcharts-text tspan {\n  color: #828282;\n  font-size: 14px;\n  font-family: 'Circular Std Book' !important;\n  font-weight: normal;\n  line-height: 15.336px;\n}\n\n.apexcharts-yaxis-texts-g {\n  text-align: start !important;\n}\n.apexcharts-xaxis-texts-g, .apexcharts-xaxis-inversed-texts-g {\n  text-align: start !important;\n}\n\n.apexcharts-yaxis .apexcharts-text tspan {\n  color: #1B1C1E;\n  font-size: 16px;\n  font-family: 'Circular Std Bold' !important;\n  font-weight: 800;\n  line-height: 15.336px;\n}\n\n.apexcharts-bar-series .apexcharts-series {\n  margin: 30px 0px !important;\n}\n\n.apexcharts-legend.apx-legend-position-bottom {\n  justify-content: left !important;\n}\n\n.apexcharts-legend-series {\n  margin-top: 20px !important;\n}\n\n.apexcharts-legend .apexcharts-legend-text {\n  font-size: 15px !important;\n  font-family: 'Circular Std Bold' !important;\n}\n\n.form-input:focus, .form-control:focus, .form-control:active, input:focus, input:active,  .form-select:focus, input:focus, textarea:focus, select:focus{\n  outline: none !important;\n  border: none !important;\n}\n\n.table thead tr {\n  border-bottom: 1px solid #000000;\n}\n.table, .table thead tr th, .table tbody tr td  {\n  background-color: transparent !important;\n  padding: 12px 4px !important;\n}\n\n.exchangeIcon {\n  transform: rotate(90deg) !important;\n}\n\n.modal-head-bg {\n  background-image: url('assets/images/head-bg.png');\n  background-size: cover;\n  border-radius: 5px;\n}\n\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.offcanvas-header {\n  text-align: end !important;\n  display: block !important;\n}\n\n.form-check-input:focus, .form-check-input:active {\n  outline: none !important;\n}\n.form-check-input:checked {\n  outline: none !important;\n  background-color: #008CFE !important;\n  border-color: #008CFE !important;\n}\n\n.big-text.big-content { \n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invoiceTable {\n  height: 25vh;\n  max-height: fit-content;\n}\n\n.invoiceTable, .invoiceTable td, .invoiceTable th, .invoiceTable thead, .invoiceTable thead tr, .invoiceTable thead tr td {\n  border: none !important;\n}\n\n/* Custom Scrollbar Styles */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n/* Ensure scrollbars are visible only when needed */\n* {\n  -ms-overflow-style: auto;\n  scrollbar-width: auto;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 5px;\n  padding: 2px !important;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #008CFE;\n  border-radius: 5px;\n  width: 8px !important;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #007ee4;\n}\n\n.truncate-cell {\n  max-width: 30vw; /* Adjust the max-width as needed */\n  white-space: nowrap;\n  cursor: pointer;\n  overflow: hidden;\n  text-wrap: nowrap;\n  word-wrap: normal;\n  text-overflow: ellipsis;\n  overflow-wrap: break-word;\n}\n\n.truncate-cell img {\n  display: none;\n}\n\n.richText-content img {\n  width: 60%;\n  height: auto;\n}\n\n.file-upload-container {\n  border: #807E7C 1px dashed;\n  padding: 20px;\n  text-align: center;\n}\n\n.search-area svg {\n  z-index: 1;\n  margin: auto;\n}\n.search-area .search-input {\n  outline: none !important;\n  border: none !important;\n  margin-left: -40px;\n  padding: 8px 50px;\n  width: 400px;\n}\n\n@media screen and (max-width: 700px) {\n  .truncate-cell {\n    max-width: 90vw; /* Adjust the max-width as needed */\n    white-space: nowrap;\n    cursor: pointer;\n    overflow: hidden;\n    text-wrap: nowrap;\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;\n  }\n  \n  .richText-content img {\n    width: 90%;\n    height: auto;\n  }\n}\n\n\n.chat-input {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n}\n\n.attachment-input .attachments {\n  display: flex;\n}\n\n.attachment-preview {\n  position: relative;\n  margin-right: 10px;\n}\n\n.preview-img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n}\n\n.remove-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: red;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.text-input input {\n  width: 100%;\n  padding: 10px;\n  margin-top: 10px;\n}\n\n.audio-preview {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.remove-btn, .record-again-btn {\n  margin-left: 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n\n.record-again-btn {\n  background-color: blue;\n}\n\n.record-btn {\n  background-color: blue;\n  color: white;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.send-btn {\n  align-self: flex-end;\n  background-color: green;\n  color: white;\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.PhoneInputCountryIconImg {\n  width: 60px;\n  position: relative;\n}\n\n.PhoneInput {\n  margin-left: 0px;\n  background-color: #F2F2F2 !important;\n  padding: 11px  !important;\n  color: #363636 !important;\n  border-radius: 10px 10px 0px 0px !important;\n  border: none;\n  border-bottom: 2px solid #000000 !important;\n}\n\n.PhoneInputInput {\n  border: none;\n  background-color: #F2F2F2 !important;\n}\n\n\n.gpdr-button {\n  text-align: start;\n  padding: 10px 30px;\n  border: none;\n  background-color: transparent;\n  display: block;\n  border-radius: 50px;\n  width: 100%;\n}\n\n.gpdr-button:hover {\n  font-weight: 600;\n  padding: 10px 30px;\n  border: none;\n  background-color: #B3DDFF;\n  display: block;\n  border-radius: 50px;\n}\n\n.invoice-width {\n  width: 60% !important;\n}\n\n.enterpriseTab.active {\n  background-color: #008CFE !important;\n  color: #fff !important;\n}\n\n.status-pending {\n  background-color: #F6CA53 !important;\n  color: white !important;\n  border: none !important;\n}\n\n.status-resolved {\n  background-color: #219653 !important;\n  color: white !important;\n  border: none !important;\n}\n\n.sticky-thead thead th {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
